<template>
  <b-modal
    :hide-footer="true"
    title="Registrar Frequência"
    centered
    size="md"
    id="add-acomp-medida-mensal"
    :no-close-on-backdrop="true"
  >
    <form @submit.prevent="submit" ref="addItem">
      <div class="row">
        <form-calendar
          v-model="data"
          grid="6"
          :minDate="item.acomp_inicial"
          :maxDate="item.acomp_final"
          label="Dia"
          :required="true"
        />

        <form-select
          v-model="compareceu"
          label="Compareceu?"
          :itens="$root.arrays.pergunta"
          :required="true"
          grid="6"
        />
      </div>
      <div class="row" v-if="compareceu == 1">
        <form-calendar
          v-model="entrada"
          grid="6"
          mode="time"
          label="Entrada"
          :required="true"
        />
        <form-calendar
          v-model="saida"
          grid="6"
          mode="time"
          label="Saída"
          :required="true"
        />
      </div>

      <div class="row pt-4 px-2 d-flex justify-content-end">
        <button
          type="submit"
          class="btn btn-success btn-add-acomp_medida"
          data-style="zoom-in"
        >
          <i class="mdi mdi-content-save"></i>
          Salvar
        </button>
      </div>
    </form>
  </b-modal>
</template>
<script>
  export default {
    props: ["item"],
    data() {
      return {
        compareceu: null,
        data: "",
        entrada: "",
        saida: "",
      };
    },
    methods: {
      submit() {
        let ladda = Ladda.create(document.querySelector(".btn-add-acomp_medida"));
        ladda.start();
        axios
          .post("api/dashboard/medidas/acomp/mensal", {
            data: this.data,
            compareceu: this.compareceu,
            entrada: this.entrada,
            saida: this.saida,
            medida_id: this.item.id,
          })
          .then((response) => {
            this.$snack.success({
              button: false,
              text: "Cadastrado com sucesso.",
            });

            this.item.acompMensal = response.data.data.acompMensal;
            this.$bvModal.hide("add-acomp-medida-mensal");

            this.compareceu = "";
            this.data = "";
            this.entrada = "";
            this.saida = "";
            ladda.stop();
          })
          .catch(() => ladda.stop());
      },
    },
  };
</script>
